module.exports = __webpack_public_path__ + "img/undefined-img.ab3d6703.png";